import { gql } from '@apollo/client';

/**
 * TT 预分拣码候选查询（tt_presort_config）：
 * 按 fromCode（TT 三段码第一段，即页面级 defaultTtFromCode）+ 尾程商（FinalMileCarrier.value）
 * 一次拉该组合全量候选（数十行），行数据就绪即预取；下一站（分拣规则第二段）在前端渲染时
 * 本地严格相等过滤——配置表按下一站区分预分拣码，混入其它流向的码选中后保存/导入均能通过，
 * 但落格时预分拣码严格相等永远不成立，配出静默死格口。
 *
 * 不选 ttBizType：后端已废弃该维度（候选码仅由 始发地+下一站+尾程商 决定，且按 presortCode
 * 去重后单行携带的业务类型取自任意一条重复行），业务类型合法性由保存侧候选校验兜底。
 */
export const GET_TT_PRESORT_OPTIONS = gql`
    query GetTtPresortOptions($carrierCode: Int!, $fromCode: String) {
        getTtPresortOptions(carrierCode: $carrierCode, fromCode: $fromCode) {
            presortCode
            nextStopCode
        }
    }
`;

export interface TtPresortOption {
    presortCode: string;
    nextStopCode: string;
}

export interface GetTtPresortOptionsResponse {
    getTtPresortOptions: TtPresortOption[];
}
